<template>
  <div>
    <div v-if="hasPermiso()">
      <Upload
      v-if="userPermissions"
        :getImagenMinisterioOrganigrama="getImagenMinisterioOrganigrama"
      />

      <div class="cnt-img" v-if="!sinDatos">
        <img id="imgMinisterioOrganigrama" :src="url" alt="" />
      </div>
    </div>

    <div v-else>
      <NoData v-if="!permiso && sinDatos" />

      <div class="cnt-img" v-if="!sinDatos">
        <img id="imgMinisterioOrganigrama" :src="url" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import Upload from "./Button.vue";
import NoData from "../../../indicador/components/NoData.vue";
import { mapState } from "vuex";
import axios from "axios";
import { showAlert } from "../../../../components/tools/utils";
export default {
  components: {
    NoData,
    Upload,
  },
  data() {
    return {
      permiso: false,
      sinDatos: true,
      url: "",
      userPermission: true,
      userPermissions: true,
    };
  },
  computed: {
    ...mapState("sesion", ["usuario"]),
  },
  methods: {
    getImagenMinisterioOrganigrama: async function() {
      try {
        await axios
          .get(
            `${process.env.VUE_APP_RUTA_API}/instituciones/servicios/` +
              this.$route.params.idServicio,
            {
              headers: {
                Authorization: `JWT ${localStorage.getItem("userToken")}`,
              },
            }
          )
          .then((r) => {
            axios
              .get(
                `${process.env.VUE_APP_RUTA_API}/instituciones/ministerios/` +
                  r.data.ministerio.id,
                {
                  headers: {
                    Authorization: `JWT ${localStorage.getItem("userToken")}`,
                  },
                }
              )
              .then((res) => {
                if (res.data) {
                  if (res.data.organigrama) {
                    this.url =
                      `${process.env.VUE_APP_RUTA_API_IMG}` +
                      res.data.organigrama;
                    this.sinDatos = false;
                  } else {
                    this.sinDatos = true;
                  }
                }
              })
              .catch((e) => {
                showAlert({
                  icon: "error",
                  text: e.response
                    ? e.response.data[Object.keys(e.response.data)[0]]
                    : "error",
                  timerProgressBar: true,
                  timer: 3000,
                });
              });
          })
          .catch((e) => {
            showAlert({
              icon: "error",
              text: e.response
                ? e.response.data[Object.keys(e.response.data)[0]]
                : "error",
              timerProgressBar: true,
              timer: 3000,
            });
          });
      } catch (error) {
        showAlert({
          icon: "error",
          text: error.response
            ? error.response.data[Object.keys(error.response.data)[0]]
            : "error",
          timerProgressBar: true,
          timer: 3001,
        });
      }
    },
    hasPermiso()
    {
      console.log(this.usuario)
      const relacionUs = this.usuario.servicios.find((s) => {return s.id === this.$route.params.idServicio*1});
      if (!relacionUs) return;
      console.log(relacionUs)
      if (
        relacionUs.rolId === 6 ||
        relacionUs.permisos.find((p) => p.permisoId === 1)
      ) {
        return true
      }

    },
    obtenerRelacionUsuarioServicio() {
      const relacionUs = this.usuario.servicios.find(
        (s) => s.id === this.$route.params.idServicio
      );
      if (!relacionUs) return;
      if (
        relacionUs.rolId === 6 ||
        relacionUs.permisos.find((p) => p.permisoId === 1)
      ) {
        this.permiso = true;
      }
    },

    obtenerRevision: async function() {
      try {
        const toSend = process.env.VUE_APP_ANIO;
        const res = await axios.post(
          `${process.env.VUE_APP_RUTA_API}/instituciones/revisiones/${this.$route.params.idServicio}/ultima_revision/`,
          {
            anio: toSend,
          },
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );

        this.datosUser = res.data;
        const relacionUs = this.usuario.servicios.find(
          (s) => s.id === this.$route.params.idServicio
        );
        if (!relacionUs) return;
        // Guardar Borrador Encargado BGI
        if (
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 6)
        ) {
          this.userPermissions = false;
        }

        //Guardar y finalizar Encargado BGI
        if (
          this.datosUser.siguienteAccion === "administrador" ||
          this.datosUser.siguienteAccion === "superadministrador" ||
          (this.datosUser.a === "finalizado" && relacionUs.rolId === 6)
        ) {
          this.userPermission = false;
        }

        //Guardar y finalizar Jefe de Servicio
      } catch (error) {
        console.log(error);
      }
    },
    obtenerRelacionUsuarioServicios() {
      const relacionUs = this.usuario.servicios.find(
        (s) => s.id === this.$route.params.idServicio
      );
      if (!relacionUs) return;
      if (relacionUs.permisos.find((p) => p.permisoId === 5)) {
        this.userPermission = false;
      }
    },
  },
  mounted() {
    this.obtenerRelacionUsuarioServicio();
    this.getImagenMinisterioOrganigrama();
    this.obtenerRevision();
    this.obtenerRelacionUsuarioServicios();
  },
};
</script>

<style scoped>
.cnt-img {
  display: flex;
  justify-content: center;
  align-items: center;
}
.cnt-img > img {
  width: 50%;
}
</style>
